export default __webpack_public_path__ + "static/media/ATLAS.a30a2c7c.png";